module.exports = __webpack_public_path__ + "static/media/og_podcasty.48fc42b9.png";